import service from '@/request/service';

// 獲取開標信息
export function getOpenBidById(data) {
  return service({
    url: '/openBid/info/getOpenBidById/' + data.openBidId,
    method: 'get'
  });
}

// 获取一阶段评标是否全部结束
export function getOneStageEvalBidAllEnd(data) {
  return service({
    url: '/openBid/info/getOneStageEvalBidAllEnd/' + data.domainId,
    method: 'get'
  });
}

// 获取开标阶段
export function getOpenBidStage(params) {
  return service({
    url: '/openBid/info/getOpenbidStage',
    method: 'get',
    params: params
  });
}

// 获取是否当前开标步骤完成之后流标
export function getFailBidAfterOpenStepFinish(params) {
  return service({
    url: '/failBid/getFailBidAfterOpenStepFinish',
    method: 'get',
    params: params
  });
}

// // 获取阶段OpenbidId
// export function getOpenbidListByOpenbidId(data) {
//   return http({
//     url: '/projectList/bid/getOpenbidListByOpenbidId',
//     method: 'post',
//     data,
//   })
// }

// export function getProjectListByCode(data) {
//   return http({
//     url: '/projectList/bid/getProjectListByCode',
//     method: 'post',
//     data,
//   })
// }

// 获取通知信息
// export function getLanguage(data) {
//   return http({
//     url: '/logMsg/getLatestLogMsgByBidSectionId',
//     method: 'post',
//     data,
//   })
// }

// 获取标段信息-- 只在异议那块用到了，废弃
// export function getBidSection(data) {
//   debugger
//   return http({
//     url: '/openProject/getOpenBidSectionByBidSectionId',
//     method: 'post',
//     data,
//   })
// }

// // 获取通知列表
// export function getLanguageList(data) {
//   return http({
//     url: '/logMsg/getLogMsgLsitByBidSectionIdAndMsgTypes',
//     method: 'post',
//     data,
//   })
// }

// 一阶段评审结果
// export function getReadResultList(data) {
//   return http({
//     url: '/project/readResult/getReadResultList',
//     method: 'post',
//     data,
//   })
// }

// 开标
export function updateOpenbidStateShow() {
  return service({
    url: '/openBid/info/update/opening',
    method: 'post'
  });
}

// 流标-废弃
// export function saveFailBid(data) {
//   return http({
//     url: '/openbidFinish/failBid',
//     method: 'post',
//     data,
//   })
// }
// 获取在线用户数量
// export function getOnlineBidderList(data) {
//   return http({
//     url: '/project/openReady/getOnlineBidderList',
//     method: 'post',
//     data,
//   })
// }
